import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function StopIcon({
  className,
  dataCy,
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      dataCy={dataCy}
      fill="none"
      height={height ?? 20}
      viewBoxDimensions="0 0 20 20"
      width={width ?? 20}
    >
      <path
        d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect
        height="6"
        rx="1"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        width="6"
        x="7"
        y="7"
      />
    </SimpleIcon>
  );
}
